import { useNextLocale } from '@captaincause/lib/useNextLocale'
import { SkeletonCircle } from '@captaincause/ui/Skeletons/Circle'
import { SkeletonRectangle } from '@captaincause/ui/Skeletons/Rectangle'
import { DesktopPanelContainer } from 'components/DonatePanel/DesktopPanelContainer'
import { Header } from 'components/DonatePanel/Header'
import { DonateForm } from '../DonateForm'
import type { DonateDesktopProps } from '../index'

function DonateSkeleton() {
  return (
    <div className="flex w-full flex-col">
      <div className="flex w-full justify-between">
        <div className="flex">
          <SkeletonCircle variant="small" className="mr-3 h-8 w-8" />
          <SkeletonCircle variant="small" className="h-8 w-8" />
        </div>
        <SkeletonCircle variant="small" className="mb-4 h-8 w-8" />
      </div>
      <div className="mb-4 flex h-[664px] w-full rounded-2xl bg-white p-8">
        <div className="flex flex-col gap-y-4">
          <SkeletonRectangle variant="large" className="w-[488px] flex-1" />
          <SkeletonRectangle variant="large" className="w-[488px] flex-1" />
        </div>
        <div className="ml-10 flex h-[616px] w-full flex-col justify-between">
          <div>
            <SkeletonRectangle variant="large" className="mb-4 w-full" />
            <SkeletonRectangle variant="large" className="mb-4 h-14 w-full" />
            <SkeletonRectangle variant="medium" className="mb-2 mt-16" />
            <SkeletonRectangle variant="medium" className="mb-4 h-12 w-full" />
            <SkeletonRectangle variant="medium" className="mb-4 h-12 w-full" />
            <SkeletonRectangle
              variant="medium"
              className="mb-2 mt-6 w-[200px]"
            />
            <SkeletonRectangle variant="large" className="mb-4 h-14 w-full" />
          </div>
          <SkeletonRectangle
            variant="large"
            className="mb-4 h-14 w-full rounded-full"
          />
        </div>
      </div>
      <SkeletonRectangle
        variant="large"
        className="h-[56px] w-full rounded-full !bg-white"
      />
    </div>
  )
}

export function DesktopView({
  isLoading,
  project,
  campaign,
  token,
  close,
  switchProject,
}: DonateDesktopProps) {
  const locale = useNextLocale()

  const mixpanelPayload = {
    campaign_name: campaign.name,
    campaign_preview: campaign.is_preview,
    campaign_test: campaign.is_test,
    campaign_id: campaign.id,
    campaign: campaign.id,
    campaign_amount: campaign.displayed_amount?.amount,
    organization_name: campaign.organization.name,
  }

  if (isLoading || !project) {
    return <DonateSkeleton />
  }

  return (
    <DesktopPanelContainer
      switchProject={switchProject}
      mixpanelPayload={mixpanelPayload}
      close={close}
      project={project}
      campaign={campaign}
    >
      <Header campaign={campaign} project={project} locale={locale} />
      <DonateForm
        project={project}
        locale={locale}
        token={token}
        campaign={campaign}
      />
    </DesktopPanelContainer>
  )
}
